export enum ContentTemplateRowType {
    HeaderWithText = 'HeaderWithText',
    ImageWithHeaderAndText = 'ImageWithHeaderAndText'
}
